import { render } from "./CpmCreativeReportList.vue?vue&type=template&id=05062c72&scoped=true"
import script from "./CpmCreativeReportList.vue?vue&type=script&lang=js"
export * from "./CpmCreativeReportList.vue?vue&type=script&lang=js"

import "./CpmCreativeReportList.vue?vue&type=style&index=0&id=05062c72&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05062c72"]])

export default __exports__